<footer>
    <app-version />
</footer>
